module.exports = __webpack_public_path__ + "img/newCand-word-doc.7b3c9bcb.svg";